import React from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Mail, ArrowRight } from 'lucide-react';
export function AboutSection() {
  return <Section className="bg-gradient-to-b from-white to-gray-50" id="about" data-id="element-106">
      <Container data-id="element-107">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-108">
          {/* Left Column: Company Story */}
          <div data-id="element-109">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-100 text-cyan-800 text-xs font-bold tracking-wide uppercase mb-6" data-id="element-110">
              100% Australian Owned • 20+ Years Experience
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-111">
              About Digital Printing
            </h2>

            <div className="space-y-6 text-gray-600 text-lg leading-relaxed" data-id="element-112">
              <p data-id="element-113">
                Digital Printing Pty Ltd is a dynamic online printing hub where
                creativity meets craftsmanship. We strive to offer innovative
                design, marketing, and printing solutions tailored to elevate
                your brand across every touchpoint.
              </p>
              <p data-id="element-114">
                We are proud to be 100% Australian Owned with 20+ years of
                experience. Being an online company, we still pride ourselves on
                delivering outstanding personal customer service via phone and
                email.
              </p>
              <p data-id="element-115">
                We understand printing can sometimes be a little confusing and
                daunting, so we are committed to making the process as simple as
                possible. We have an easy-to-use online ordering system, and we
                also provide comprehensive artwork instructions, resources and
                guideline templates for you to use for our entire product range.
              </p>
            </div>
          </div>

          {/* Right Column: Design Help CTA */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 relative overflow-hidden" data-id="element-116">
            {/* Decorative background blobs */}
            <div className="absolute top-0 right-0 -mr-16 -mt-16 w-48 h-48 bg-cyan-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50" data-id="element-117"></div>
            <div className="absolute bottom-0 left-0 -ml-16 -mb-16 w-48 h-48 bg-magenta-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50" data-id="element-118"></div>

            <div className="relative z-10" data-id="element-119">
              <div className="flex justify-center mb-6" data-id="element-120">
                <img src="https://cdn.magicpatterns.com/uploads/3bcqf4k6a9sg46hUAHbxoH/Mascot_names.png" alt="Digital Printing Team Mascots" className="w-48 h-auto drop-shadow-md" data-id="element-121" />
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-122">
                Don't have press ready artwork?
              </h3>

              <p className="text-gray-600 mb-6 text-center" data-id="element-123">
                There is no need to stress! Our experienced and committed design
                team can make your existing files press ready or we can design
                your artwork from scratch and bring your vision to life.
              </p>

              <div className="bg-gray-50 rounded-xl p-5 mb-6 border border-gray-100" data-id="element-124">
                <p className="text-sm text-gray-700 mb-3 font-medium text-center" data-id="element-125">
                  If you need any assistance, our knowledgeable print and design
                  team are always on hand to provide expert printing advice and
                  service.
                </p>
                <a href="mailto:sales@digitalprintingoz.com.au" className="flex items-center justify-center text-cyan-600 font-bold hover:text-cyan-700 transition-colors" data-id="element-126">
                  <Mail className="w-4 h-4 mr-2" data-id="element-127" />
                  sales@digitalprintingoz.com.au
                </a>
              </div>

              <Button fullWidth size="lg" onClick={() => document.getElementById('quote')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-128">
                Contact Us
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-129" />
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </Section>;
}